export const createIndexSizeError = () => {
    try {
        return new DOMException('', 'IndexSizeError');
    }
    catch (err) {
        // Bug #122: Edge is the only browser that does not yet allow to construct a DOMException.
        err.code = 1;
        err.name = 'IndexSizeError';
        return err;
    }
};
//# sourceMappingURL=index-size-error.js.map